/**
 * Chairman Reports Service
 * API client for chairman reports
 */
import api from './api';

const chairmanReportsService = {
  /**
   * Get cross-module assessment navigation metadata
   * @returns {Promise<Object>} API response
   */
  getAssessmentModules: async () => {
    const response = await api.get('/chairman/reports/assessment/modules');
    return response.data;
  },

  /**
   * Get HR Performance Report
   * @param {Object} filters - Filter options
   * @param {string} filters.fromDate - Start date (optional)
   * @param {string} filters.toDate - End date (optional)
   * @param {string} filters.hrId - Specific HR ID (optional)
   * @returns {Promise<Object>} API response
   */
  getHRPerformanceReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.hrId) params.append('hrId', filters.hrId);
    
    const response = await api.get(`/chairman/reports/hr-performance?${params.toString()}`);
    return response.data;
  },

  /**
   * Get Summary Report
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getSummaryReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.countryId) params.append('countryId', filters.countryId);
    if (filters.jobRoleId) params.append('jobRoleId', filters.jobRoleId);
    
    const response = await api.get(`/chairman/reports/summary?${params.toString()}`);
    return response.data;
  },

  /**
   * Get Interview Report
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getInterviewReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.countryId) params.append('countryId', filters.countryId);
    if (filters.jobRoleId) params.append('jobRoleId', filters.jobRoleId);
    
    const response = await api.get(`/chairman/reports/interview?${params.toString()}`);
    return response.data;
  },

  /**
   * Get Exam Report
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getExamReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.countryId) params.append('countryId', filters.countryId);
    if (filters.jobRoleId) params.append('jobRoleId', filters.jobRoleId);
    
    const response = await api.get(`/chairman/reports/exam?${params.toString()}`);
    return response.data;
  },

  /**
   * Get Departure Report
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getDepartureReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.countryId) params.append('countryId', filters.countryId);
    if (filters.jobRoleId) params.append('jobRoleId', filters.jobRoleId);
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    
    const response = await api.get(`/chairman/reports/departure?${params.toString()}`);
    return response.data;
  },

  /**
   * Get Payment Report
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getPaymentReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    if (filters.countryId) params.append('countryId', filters.countryId);
    if (filters.jobRoleId) params.append('jobRoleId', filters.jobRoleId);
    
    const response = await api.get(`/chairman/reports/payment?${params.toString()}`);
    return response.data;
  },

  /**
   * Get HR Report (Attendance/Performance)
   * @param {Object} filters - Filter options
   * @returns {Promise<Object>} API response
   */
  getHRReport: async (filters = {}) => {
    const params = new URLSearchParams();
    
    if (filters.fromDate) params.append('fromDate', filters.fromDate);
    if (filters.toDate) params.append('toDate', filters.toDate);
    
    const response = await api.get(`/chairman/reports/hr?${params.toString()}`);
    return response.data;
  }
};

export default chairmanReportsService;